<script lang="ts">
  // BJL-CHECK: DateTimePicker, Button — the native `<input type="datetime-local">` is
  // deliberate: on Android it opens the OS date/time wheels, which a JS calendar can't
  // match for a one-handed "leave at 6:40" edit. See artifacts/deviations/PlanPage.md.
  import { Button } from '@byjackli-labs/ui/Button'
  import { Colors } from '../../ui/colors'
  import { useTripPlanStore } from '../../store/tripPlan'
  import { storeSelect } from '../../lib/store.svelte'

  const departAt = storeSelect(useTripPlanStore, (s) => s.departAt)
  let showPicker = $state(false)

  // datetime-local wants "YYYY-MM-DDTHH:mm" in the user's local zone.
  const localValue = $derived.by(() => {
    const d = new Date((departAt.value ?? Math.floor(Date.now() / 1000)) * 1000)
    const pad = (n: number) => String(n).padStart(2, '0')
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`
  })

  const armed = $derived(departAt.value !== null || showPicker)
</script>

<div style="display: flex; flex-direction: column; align-items: stretch; gap: 8px; width: 100%;">
  <Button
    variant={armed ? 'default' : 'secondary'}
    size="sm"
    aria-pressed={armed}
    onclick={() => {
      if (showPicker || departAt.value !== null) {
        useTripPlanStore.getState().setDepartAt(null)
        showPicker = false
      } else {
        showPicker = true
      }
    }}
    style="width: 100%;"
  >{armed ? '✕ Depart at' : 'Leave now ▾'}</Button>
  {#if armed}
    <input
      type="datetime-local"
      value={localValue}
      aria-label="Departure time"
      onchange={(e) => {
        const t = new Date(e.currentTarget.value).getTime()
        if (Number.isFinite(t)) useTripPlanStore.getState().setDepartAt(Math.floor(t / 1000))
      }}
      style="
        background-color: {Colors.surfaceElevated}; border: 1px solid {Colors.border};
        border-radius: 8px; padding: 4px 8px; color: {Colors.text}; font-size: var(--bjl-font-size-sm);
        color-scheme: dark; width: 100%; box-sizing: border-box;
      "
    />
  {/if}
</div>
